<template>
    <div class="vw-100 vh-100 row g-0">
        <div class="col-12 col-sm-4 col-lg-3 col-xl-2 bg-primary ">
            <div class="text-center small text-light position-absolute px-1">
                <small>v{{version}}</small>
            </div>
            <div class="d-flex flex-column h-100 p-3">
                <div>
                    <img src="../assets/logo_tf_blanco_solo.png" class="w-100 p-3">
                </div>
                <div class="flex-grow-1 mt-3">
                    <div>
                        <label class="form-label mb-0 text-light">Email</label>
                        <input name="email" type="text" class="form-control" v-model="email">
                        <form-error name="email" :errors="errors"></form-error>
                    </div>
                    <div>
                        <label class="form-label mb-0 text-light">Contraseña</label>
                        <input name="password" type="password" class="form-control" v-model="password"
                            @keyup.enter="login">
                        <form-error name="password" :errors="errors"></form-error>
                    </div>
                    <div>
                        <button :disabled="working"
                                class="btn btn-outline-light w-100 mt-3" @click="login">
                            Iniciar sesión
                        </button>
                    </div>
                </div>
                <div class="p-3">
                    <img src="../assets/dev_by_white.png" class="w-100">
                </div>
            </div>

        </div>
        <div class="d-none d-sm-block col-sm-8 col-lg-9 col-xl-10 login-bg text-white">
            <div class="p-4 lh-1">
                <h4 class="mb-0">Tres Factorial</h4>
                <span>Bienvenido</span>
            </div>
        </div>
    </div>
</template>

<script>
    import FormError from "../components/utils/FormError";

    export default {
        name: 'Login',
        components: {
            FormError
        },
        data() {
            return {
                email: null,
                password: null,
                errors: [],
                working: false,
                version: process.env.VUE_APP_VERSION
            }
        },
        methods: {
            login() {
                this.errors = [];
                this.working = true;
                axios.post('/login', {
                    email: this.email,
                    password: this.password,
                    remember: true
                }).then(res => {
                    this.$router.replace('/');
                }).catch(err => {
                    this.errors = err.response.data.errors;
                    this.working = false;
                });
            }
        }
    }
</script>

<style>
    .login-bg {
        background: url("../assets/purple.jpg") center;
        background-size: cover;
    }
</style>